var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-start text--black",attrs:{"id":_vm.holder}})
}
var staticRenderFns = []

export { render, staticRenderFns }